import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/AdsSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faLightbulb, faChartBar, faBullseye, faMoneyBill, faGem } from '@fortawesome/free-solid-svg-icons';

const AdsSection: React.FC = () => {
  const { user } = useAuth();
  const isPremium = user?.isPremium;
  const navigate = useNavigate();

  // Não mostrar anúncios para usuários Premium
  if (isPremium) {
    return null;
  }

  return (
    <div className="ads-section">
      <div className="ad-banner">
        <div className="ad-content">
          <h3><FontAwesomeIcon icon={faStar} /> Upgrade para Premium</h3>
          <p>Aproveite análises avançadas, sugestões de IA e muito mais!</p>
          <ul className="ad-features">
            <li><FontAwesomeIcon icon={faLightbulb} /> Sugestões de investimento com IA</li>
            <li><FontAwesomeIcon icon={faChartBar} /> Análises financeiras completas</li>
            <li><FontAwesomeIcon icon={faBullseye} /> Decisões financeiras inteligentes</li>
            <li><FontAwesomeIcon icon={faMoneyBill} /> Receitas e despesas detalhadas</li>
          </ul>
          <button className="ad-cta-btn"
          onClick={() => navigate('/premium')}>
            Aproveitar Oferta Agora
          </button>
        </div>
        <div className="ad-visual">
          <span className="ad-emoji"><FontAwesomeIcon icon={faGem} /></span>
        </div>
      </div>
    </div>
  );
};

export default AdsSection;
